import api from './api';

export const tabService = {
  saveTab: async (ticketId, userId, title) => {
    const tabData = {
      ticket_id: ticketId,
      user_id: userId,
      title: title,
    };

    const response = await api.post('/tabs/addTabs', tabData);
    return response.data;
  },

  getCustomTabNames: async (ticketId) => {
    const response = await api.get('/tabs/customTabNames', {
      params: { ticket_id: ticketId }
    });
    return response.data;
  },

  updateCustomTabName: async (ticketId, tabNumber, customName, colorData = {}) => {
    const response = await api.put('/tabs/customTabNames', {
      ticket_id: ticketId,
      tab_number: tabNumber,
      custom_name: customName,
      bgcolor: colorData.bgcolor || null,
      nocolor: colorData.nocolor || null,
      hovercolor: colorData.hovercolor || null,
    });
    return response.data;
  }
};